import CheckroomIcon from "@mui/icons-material/Checkroom";
import CodeIcon from "@mui/icons-material/Code";
import DeveloperModeIcon from "@mui/icons-material/DeveloperMode";
import FaceRetouchingNaturalIcon from "@mui/icons-material/FaceRetouchingNatural";
import FitnessCenterIcon from "@mui/icons-material/FitnessCenter";
import FlagIcon from "@mui/icons-material/Flag";
import HomeIcon from "@mui/icons-material/Home";
import LiveTvIcon from "@mui/icons-material/LiveTv";
import MusicNoteIcon from "@mui/icons-material/MusicNote";
import OndemandVideoIcon from "@mui/icons-material/OndemandVideo";
import SchoolIcon from "@mui/icons-material/School";
import SportsCricketIcon from "@mui/icons-material/SportsCricket";
import SportsEsportsIcon from "@mui/icons-material/SportsEsports";
import TheaterComedyIcon from "@mui/icons-material/TheaterComedy";
import WhatshotIcon from "@mui/icons-material/Whatshot";

export const categories = [
  { name: "New", icon: <HomeIcon /> },
  { name: "Hot", icon: <WhatshotIcon /> },
  { name: "Siedd", icon: <MusicNoteIcon /> },
  { name: "Coding", icon: <CodeIcon /> },
  { name: "World News", icon: <FlagIcon /> },
  { name: "VS Code", icon: <CodeIcon /> },
  { name: "Music", icon: <MusicNoteIcon /> },
  { name: "Education", icon: <SchoolIcon /> },
  { name: "Cricket", icon: <SportsCricketIcon /> },
  { name: "Movie", icon: <OndemandVideoIcon /> },
  { name: "Gaming", icon: <SportsEsportsIcon /> },
  { name: "Live", icon: <LiveTvIcon /> },
  { name: "Sport", icon: <FitnessCenterIcon /> },
  { name: "Fashion", icon: <CheckroomIcon /> },
  { name: "Beauty", icon: <FaceRetouchingNaturalIcon /> },
  { name: "Comedy", icon: <TheaterComedyIcon /> },
  { name: "Gym", icon: <FitnessCenterIcon /> },
  { name: "Crypto", icon: <DeveloperModeIcon /> },
];

export const demoThumbnailUrl =
  "https://images.unsplash.com/photo-1663287695452-bf59337d8746?auto=format&fit=crop&w=1170&q=80";
export const demoChannelUrl = "/channel/UC9Jrzve0dhPoo_LexakSFMw";
export const demoVideoUrl = "/video/zdtHCSvTrp0";
export const demoChannelTitle = "Siedd";
export const demoVideoTitle =
  "Siedd - Losing My Mind [Official Nasheed Video] | Vocals Only";
export const demoProfilePicture =
  "https://yt3.ggpht.com/S07NWoiPpR-_1x-Mhymdyiy7Au0PP2MVPMLQ6HqOxDJ17EEz_edxsjh8Uud4rmE-UWKb5a2Ql1c=s88-c-k-c0x00ffffff-no-rj";
